import { render, staticRenderFns } from "./SettlementCard.vue?vue&type=template&id=25af86ac"
import script from "./SettlementCard.vue?vue&type=script&lang=js"
export * from "./SettlementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports